/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// libraries
import React, { useEffect } from 'react';
import {
    object, string, shape, func,
} from 'prop-types';
import { withRouter } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import ReactMarkdown from 'react-markdown';
import Grid from '@material-ui/core/Grid';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DesktopMobile from '../../../helpers/DesktopMobile/DesktopMobile';
import GraphqlBreadcrumbs from '../GraphqlCommonComponents/GraphqlBreadcrumbs/GraphqlBreadcrumbs';
import GraphqlSeoHeadTags from '../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import CouponPageUIDesktop from './CouponPageUIDesktop';
import CouponPageUIMobile from './CouponPageUIMobile';
import FaqSeoSchema from '../../../helpers/Seo/FaqSeoSchema';
import FAQBlockV2 from '../GraphqlCommonComponents/FAQBlockV2/FAQBlockV2';
import { trackEvent as track } from '../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const useStyles = makeStyles((theme) => ({
    container: {
        margin: 'auto',
        padding: '10px',
    },
    breadCrumbs: {
        maxWidth: '980px',
    },
    couponsWrapper: {
        display: 'flex',
        justifyContent: 'space-evenly',
        margin: '0 auto',
        padding: 10,
    },
    couponHeader: {
        textAlign: 'center',
    },
    couponMain: {
        display: 'flex',
        justifyContent: 'space-between',
        borderColor: theme?.palette?.primary?.[200] || '#d5d5d5',
        borderStyle: 'solid',
        borderWidth: '0 0 1px 0',
        borderRadius: 0,
    },
}));

const CouponPageUI = ({ pageData, trackEvent }) => {
    const classes = useStyles();
    const {
        header, footer, data, seo = {}, panelBackgroundColor, faq,
    } = pageData;

    useEffect(() => {
        trackEvent({
            eventCategory: pageData?.tracking?.tracking_event_category || 'Coupon Page',
            eventAction: pageData?.tracking?.tracking_event_action || 'Coupon Page',
            eventLabel: pageData?.tracking?.tracking_event_label || 'Coupon Page',
        });
    }, []);

    return (
        <>
            <GraphqlSeoHeadTags seoData={seo} />
            { faq?.faqs && (<FaqSeoSchema faqArray={faq.faqs} />)}
            <div className={classes.container}>
                <Grid container justify="center">
                    {seo?.breadcrumb && (
                        <Grid xs={12} md={9} item className={classes.breadCrumbs}>
                            <GraphqlBreadcrumbs breadCrumbArray={seo.breadcrumb} />
                        </Grid>
                    )}
                    <Grid xs={12} md={9} item>
                        <ReactMarkdown className={classes.couponHeader} escapeHtml={false} source={header} />
                    </Grid>
                    <DesktopMobile
                        desktop={() => <CouponPageUIDesktop data={data} panelBackgroundColor={panelBackgroundColor} />}
                        mobile={() => <CouponPageUIMobile data={data} panelBackgroundColor={panelBackgroundColor} />}
                        breakpoint={700}
                    />
                    { faq?.faqs && (
                        <>
                            <FAQBlockV2 faqBlock={faq} />
                            <Grid xs={12} md={9} item>
                                <ReactMarkdown className={classes.couponHeader} source={footer} />
                            </Grid>
                        </>
                    )}
                </Grid>
            </div>
        </>
    );
};

CouponPageUI.propTypes = {
    pageData: shape({
        header: string.isRequired,
        footer: string.isRequired,
        data: object.isRequired,
        faq: object.isRequired,
        panelBackgroundColor: object.isRequired,
        brand: shape({
            'domain-name': string,
        }),
    }).isRequired,
    trackEvent: func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
});

export default withRouter(connect(null, mapDispatchToProps)(CouponPageUI));
